import { Link } from 'react-router-dom'
import { Avatar } from '@campgladiator/cgui-core.atoms.avatar'
import { Button } from '@campgladiator/cgui-core.atoms.button'
import { Card } from '@campgladiator/cgui-core.atoms.card'
import { Icon } from '@campgladiator/cgui-core.atoms.icon'
import { Paragraph } from '@campgladiator/cgui-core.atoms.typography'
import { Workout } from '../../../../redux/features/OnDemand/onDemandWorkouts'
import { Favorite } from '../../../../common/components/Favorite'
import { trainerFullName } from '../../../../common/utility/trainer'
import {
  BottomPartCardProps,
  TagsProps,
  UpperPartCardProps,
  WorkoutCardProps,
} from '../../OnDemandWorkouts.d'
import styles from './WorkoutCard.module.scss'

const Tags = ({ items }: TagsProps) => (
  <div className={styles.tags}>
    {items.map((tag, index) => (
      <Button
        key={index}
        className={styles.tag}
        size="xsmall"
        emphasis="secondary-alt"
        variation="outline"
        disabled
      >
        {tag.title}
      </Button>
    ))}
  </div>
)

const createUrlToDetailsPage = (workout: Workout) => `/workout/${workout.id}`

const PlayIconOverlay = () => (
  <div className={styles.playIconOverlay}>
    <div className={styles.circle}>
      <Icon className={styles.icon} name="icon-play-line" />
    </div>
  </div>
)

const UpperPartCard = ({ workout }: UpperPartCardProps) => {
  const trainerName = workout.trainer ? trainerFullName(workout.trainer) : null
  return (
    <Link
      className={styles.blockLink}
      to={{
        pathname: createUrlToDetailsPage(workout),
      }}
    >
      <div
        className={styles.upperPart}
        style={{ backgroundImage: `url(${workout.photo})` }}
      >
        {workout.trainer && trainerName ? (
          <div className={styles.detailsWrapper}>
            <div className={styles.details}>
              <div className={styles.trainerInfo}>
                <Avatar
                  alt={trainerName}
                  size="40px"
                  src={workout.trainerPhoto || workout.trainer.photo}
                />
                <div className={styles.nameWrapper}>
                  <Paragraph size="xsmall" weight="book">
                    Trainer
                  </Paragraph>
                  <Paragraph size="small" weight="bold">
                    {trainerName}
                  </Paragraph>
                </div>
              </div>
            </div>
          </div>
        ) : null}
        <PlayIconOverlay />
      </div>
    </Link>
  )
}

const BottomPartCard = ({ workout }: BottomPartCardProps) => {
  const hiddenTagTypes = ['equipment', 'constraint']
  const visibleTags = workout.tags.filter(
    (tag) => !hiddenTagTypes.includes(tag.tagType),
  )

  return (
    <div className={styles.bottomPart}>
      <Paragraph className={styles.workoutTitle}>
        <Link className={styles.textLink} to={createUrlToDetailsPage(workout)}>
          {workout.title}
        </Link>
      </Paragraph>
      {visibleTags.length > 0 && <Tags items={visibleTags} />}
    </div>
  )
}

const WorkoutCard = ({
  workout,
  isLoggedIn,
  onFavoriteClick,
  isLoadingFavorite,
}: WorkoutCardProps) => (
  <Card className={styles.card} raised>
    {isLoggedIn && (
      <Favorite
        condensed
        isLoadingFavorite={isLoadingFavorite}
        isFavorite={workout.favorite}
        workoutId={workout.id}
        onClick={() => onFavoriteClick(workout.id, workout.favorite)}
      />
    )}
    <UpperPartCard workout={workout} />
    <BottomPartCard workout={workout} />
  </Card>
)

export default WorkoutCard
